export default "__VITE_ASSET__Cr5WEsvR__"